import React, { Component } from 'react';
import './App.css';
import Control from './Control';

class App extends Component {
  render() {
    return (
      <div class="container-fluid">
        <nav class="navbar navbar-default">
          <div class="container-fluid">
            <div class="navbar-header">
              <span class="navbar-brand" href="#">FFXIV Samurai Opener Simulator</span>
            </div>
          </div>
        </nav>
        <div class="col-sm-12">
          <Control />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js